/**
 * Detect fn
 */
export default () => 'document' in self && 'currentScript' in self.document
